import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import useWindowSize from '@propertypal/shared/src/hooks/useWindowSize';
import { Property } from '@propertypal/shared/src/types/property';
import {
  calculatePercentagesFromArrayOfImages,
  getGalleryChunks,
} from '@propertypal/shared/src/utils/property/galleryHelpers';
import getGalleryImages from '@propertypal/shared/src/utils/property/getGalleryImages';
import React, { CSSProperties, FunctionComponent } from 'react';
import useMediaQuery from '../media-query/useMediaQuery';
import { Container, ImageRow, PropertyImage } from './ImageGrid.style';

interface Props {
  containerStyle?: CSSProperties;
  property: Property;
  imageLocator: string;
  onImageClick: (index: number) => void;
  hasSitemap: boolean;
}

const ImageGrid: FunctionComponent<Props> = (props) => {
  const windowSize = useWindowSize();
  const isMobile = useMediaQuery({ query: `(${mobileXXLargeMax})` });
  const images = getGalleryImages(props.property, props.imageLocator, false, false, !props.hasSitemap);
  const chunks = getGalleryChunks(images, isMobile ? [1, 2] : [2, 3]);

  return (
    <Container id="image-grid" data-testid="imageGrid" style={props.containerStyle}>
      {chunks.map((chunk) => {
        const imageWidths = calculatePercentagesFromArrayOfImages(chunk.images, windowSize.width || 0);

        return (
          <ImageRow key={chunk.keyItem}>
            {chunk.images.map((image, index) => (
              <PropertyImage
                key={image.image}
                onClick={() => props.onImageClick(image.index)}
                src={image.image}
                width={image.width}
                height={image.height}
                style={{ ...imageWidths[index] }}
              />
            ))}
          </ImageRow>
        );
      })}
    </Container>
  );
};

export default ImageGrid;
